import { Component, ViewEncapsulation} from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { SmsService } from './services/sms.service';
import { ApiService } from './services/api.service';
import { LetterService } from './services/letter.service';

@Component({
    selector   : 'my-app',
    template: require('./home.component.html'),
    styles: [require('./home.component.scss')],
    encapsulation: ViewEncapsulation.None
})

export class HomeComponent {
    //menu structure exemple
    /*{
        title: 'Post-it',
        path : '/postit',
        icon : 'fa-file'
    },
    {
        title  : 'Campagnes',
            path   : '/marketing',
        icon   : 'fa-shopping-bag',
        subPath: '/marketing/add',
        subIcon: 'fa-plus',
    }*/
    menu = [
        {
            title: 'Post-it',
            path : '/postit',
            icon : 'fa-file'
        },
        {
            title: 'Tâches',
            path : '/tasks',
            icon : 'fa-tasks'
        },
        {
            title  : 'Vélos',
            path   : '/bikes',
            icon   : 'fa-bicycle'
        },
        // {
        //     title  : 'Campagnes',
        //     path   : '/marketing',
        //     icon   : 'fa-shopping-bag'
        // },
        {
            title  : 'Non payé',
            path   : '/notPaid',
            icon   : 'fa-credit-card'
        },
        {
            title  : 'Packs',
            path   : '/pack',
            icon   : 'fa-suitcase'
        },
        {
            title  : 'Export',
            path   : '/export',
            icon   : 'fa-list'
        }
    ];

    currentRoute: string;

    constructor(public router: Router, public location: Location, public smsService: SmsService, public apiService:ApiService, public letterService:LetterService) {
        this.currentRoute = location.path();

        // modifie currentRoute quand l'utilisateur change de route
        router.events.subscribe((url) => {
            this.currentRoute = url.url;
        });

        /*this.smsService.changeEmitted$.subscribe(
            text => {
                console.log(text);
            }
        )*/
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/home/home.component.ts